import { Dialog } from "primereact/dialog"
import "./NoSubscriptionDialog.scss";

export const NoSubscriptionDialog = ({ visible, onHide, onSubscribe, message, showSubscribeButton, isTestSeries, heading, primaryButtonText, secondaryButtonText, position = "center" }: any) => {
    return (
        <Dialog
            className="mock-test-dialog-box"
            position={position}
            visible={visible}
            onHide={onHide}
            closeOnEscape={true}
            showHeader={false}
        >
            <div className="pause-dialog-box">
                <div className="p-dlg-heading">
                    {heading ? heading : (isTestSeries ? 'Subscribe to Continue' : 'No Active Subscription')}
                </div>
                <span className="p-dilg-para">
                    {/* If message is provided, use it. Otherwise fallback to default test series message if isTestSeries is true */}
                    {message ? message : (isTestSeries ? 'Do you want to subscribe?' : message)}
                </span>

                <div className="tw-mt-7 tw-flex gap-3 tw-justify-center">
                    {showSubscribeButton ? (
                        <>
                            <button
                                className="ia-btn ia-btn-outline-primary"
                                onClick={onHide}
                            >
                                {secondaryButtonText ? secondaryButtonText : (isTestSeries ? 'No' : 'Cancel')}
                            </button>
                            <button
                                className="ia-btn ia-btn-primary"
                                onClick={onSubscribe}
                            >
                                {primaryButtonText ? primaryButtonText : (isTestSeries ? 'Yes' : 'Subscribe')}
                            </button>
                        </>
                    ) : (
                        <button
                            className="ia-btn ia-btn-primary"
                            onClick={onHide}
                        >
                            {primaryButtonText ? primaryButtonText : 'Ok'}
                        </button>
                    )}
                </div>
            </div>
        </Dialog>
    )
}